(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cdav", [], factory);
	else if(typeof exports === 'object')
		exports["cdav"] = factory();
	else
		root["cdav"] = factory();
})(global, () => {
return 